<template>
  <div class="goodsDetail">
    <!-- 详情模块 -->
    <div class="pop_goods" @click="active_input = ''">
      <md-popup v-model="show" position="right" @beforeHide="cancelPop">
        <div style="height:0.54rem"></div>
        <div class="pop_goods_box">
          <!-- 头部 -->
          <div class="pop_header">
            <div class="close">
              <!-- <md-icon name="wrong" size="sm" @click="cancelPop"></md-icon> -->
              <i class="iconfont icon-guanbi" style="font-size:0.24rem;" @click="cancelPop"></i>
            </div>
            <div>货品详情</div>
          </div>
          <!-- 中间 -->
          <div class="pop_section">
            <template v-if="Object.keys(item).length">
              <!-- 商品基础详情 -->
              <div class="goods_base">
                <div class="mask"></div>
                <template v-if="item.status != 2">
                  <div class="goods_name">
                    <span class="input_name" :active="active_input == 'name'" style="padding: 0.04rem 0.06rem">
                      <span class="label">货品名称：</span>
                      <input type="text" v-model="subData.name" @click.stop="active_input = 'name'">
                      <span class="label_right">
                        <div class="goods_item_type">
                          <span class="goods_item_type_1" v-if="item.bale ==1">定装</span>
                          <span class="goods_item_type_2" v-if="item.bale ==2">非定装</span>
                          <span class="goods_item_type_3" v-if="item.bale ==3">散装</span>
                          <span class="goods_item_type_4" v-if="item.goods_type == 2">附加费</span>
                        </div>
                      </span>
                    </span>
                  </div>
                  <div class="goods_label" style="margin-bottom:0.08rem">
                    <span class="input_name" style="background-color:transparent;border:none;">
                      <span class="label">售卖类型：</span>
                      <span class="radio">
                        <md-radio-group v-model="subData.type">
                          <md-radio name="1" label="自营　"/>
                          <md-radio name="2" label="代卖　" />
                        </md-radio-group>
                      </span>
                    </span>
                  </div>
                  <div class="goods_label" style="margin-bottom:0.08rem">
                    <span class="input_name" :active="active_input == 'price'" style="padding: 0.04rem 0.06rem">
                      <span class="label">销售价格：</span>
                      <input type="number" style="text-align:right" v-model="subData.proposed_price" @click.stop="active_input = 'price'">
                      <span class="label">元</span>
                    </span>
                  </div>
                  <div class="goods_label" style="margin-bottom:0.08rem">
                    <span class="input_name" style="background-color:transparent;border:none">
                      <span class="label">库存类型：</span>
                      <span class="radio">
                        <md-radio-group v-model="subData.is_strong">
                          <md-radio name="1" label="弱库存"/>
                          <md-radio name="2" label="强库存" />
                        </md-radio-group>
                      </span>
                    </span>
                  </div>
                </template>
                <template v-if="item.status == 2">
                  <div class="goods_name">
                    <span class="label">货品名称：</span>
                    <span>{{item.name}}</span>
                    <span class="label_right">
                      <div class="goods_item_type">
                        <span class="goods_item_type_1" v-if="item.bale ==1">定装</span>
                        <span class="goods_item_type_2" v-if="item.bale ==2">非定装</span>
                        <span class="goods_item_type_3" v-if="item.bale ==3">散装</span>
                        <span class="goods_item_type_4" v-if="item.goods_type == 2">附加费</span>
                      </div>
                    </span>
                  </div>
                  <div class="goods_batch goods_label">
                    <span class="label">售卖类型：</span>
                    <span><span v-if="item.type == 1">自营</span><span v-if="item.type == 2">代卖</span></span>
                  </div>
                  <!-- <div class="goods_label">
                    <span class="label">销售价格：</span>
                    <span>{{item.proposed_price}}</span>
                    <span class="label_right">元</span>
                  </div> -->
                  <div class="goods_batch goods_label">库存类型：{{item.is_strong == 1?'弱库存':'强库存'}}</div>
                </template>
                <div class="goods_bale_num goods_label" v-if="item.bale == 1">规格：{{Number(item.bale_num)}}公斤/{{unit_list[item.num_unit - 1].name}}</div>
                <div class="goods_bale_cate goods_label" v-if="item.supplier">
                  货主：<span style="color:#31B158">{{item.supplier.name}}</span>
                </div>
                <div class="goods_batch goods_label" style="color:#999;font-size:0.2rem;">批次号：{{item.batch}}</div>
                <div class="goods_date goods_label" style="color:#999;font-size:0.2rem;">入库时间：{{item.create_time | toTime}}</div>
              </div>
              <!-- 商品库存数量相关 -->
              <div class="goods_num">
                <div class="goods_label">
                  <span>进货量：</span>
                  <span v-if="item.bale == 1">{{Number(item.num)}}{{unit_list[item.num_unit - 1].name}}</span>
                  <span v-if="item.bale == 2">{{Number(item.num)}}{{unit_list[item.num_unit - 1].name}}({{Number(item.weight)}}公斤)</span>
                  <span v-if="item.bale == 3">{{Number(item.weight)}}公斤</span>
                </div>
                <div class="goods_label">
                  <span class="label">销售量：</span>
                  <span v-if="item.bale == 1">{{Number(item.xs_num)}}{{unit_list[item.num_unit - 1].name}}</span>
                  <span v-if="item.bale == 2">{{Number(item.xs_num)}}{{unit_list[item.num_unit - 1].name}}({{Number(item.xs_total)}}公斤)</span>
                  <span v-if="item.bale == 3">{{Number(item.xs_total)}}公斤</span>
                </div>
                <div class="goods_label">
                  <span class="label">库存量：</span>
                  <span v-if="item.bale == 1"><span :style="Number(item.last_total_num)<0?'color:#f00':'color:#31B158'" >{{Number(item.last_total_num)}}</span>{{unit_list[item.num_unit - 1].name}}</span>
                  <span v-if="item.bale == 2"><span :style="(Number(item.lase_num)<0 || Number(item.last_total)<0)?'color:#f00':'color:#31B158'" >{{Number(item.lase_num)}}</span>{{unit_list[item.num_unit - 1].name}}(<span :style="(Number(item.lase_num)<0 || Number(item.last_total)<0)?'color:#f00':'color:#31B158'" >{{Number(item.last_total)}}</span>公斤)</span>
                  <span v-if="item.bale == 3" ><span :style="(Number(item.last_total)<0)?'color:#f00':'color:#31B158'">{{Number(item.last_total)}}</span>公斤</span>
                </div>
                <div class="goods_label" v-if="Number(item.damaged_num)>0 || Number(item.damaged_total)>0">
                  <span class="label">报损量：</span>
                  <span v-if="item.bale == 1"><span style="color:#f79a07;">{{Number(item.damaged_num)}}</span>{{unit_list[item.num_unit - 1].name}}</span>
                  <span v-if="item.bale == 2"><span style="color:#f79a07;">{{Number(item.damaged_num)}}</span>{{unit_list[item.num_unit - 1].name}}(<span style="color:#f79a07;">{{Number(item.damaged_total)}}</span>公斤)</span>
                  <span v-if="item.bale == 3"><span style="color:#f79a07;">{{Number(item.damaged_total)}}</span>公斤</span>
                </div>
              </div>
              <!-- 变更动态 -->
              <div class="goods_brake" v-if="timeline && timeline.length>0">
                <div class="title">变更动态</div>
                <div class="content">
                  <el-timeline :reverse="false">
                    <el-timeline-item
                      size="large"
                      v-for="(activity, index) in timeline"
                      :key="index"
                      :timestamp="activity.create_time | toTime"
                      placement="top"
                    >
                      <div class="timeline">
                        <span>
                          <span>{{operateList[activity.operate -1 ]}}前：</span>
                          <template v-if="activity.goods_bale == 1">
                            <span>{{activity.before_num-0}}{{unit_list[activity.num_unit-1].name}}</span>
                          </template>
                          <template v-if="activity.goods_bale == 2">
                            <span>{{activity.before_num-0}}{{unit_list[activity.num_unit-1].name}}</span>
                            (<span>{{activity.before_weight-0}}公斤</span>)
                          </template>
                          <template v-if="activity.goods_bale == 3">
                            <span>{{activity.before_weight-0}}公斤</span>
                          </template>
                          <!-- <span class="jiantou"> >> </span> -->
                          <br>
                          <span>{{operateList[activity.operate -1 ]}}：</span>
                          <template v-if="activity.goods_bale == 1">
                            <span>{{activity.amount_num-0}}{{unit_list[activity.num_unit-1].name}}</span>
                          </template>
                          <template v-if="activity.goods_bale == 2">
                            <span>{{activity.amount_num-0}}{{unit_list[activity.num_unit-1].name}}</span>
                            (<span>{{activity.amount_weight-0}}公斤</span>)
                          </template>
                          <template v-if="activity.goods_bale == 3">
                            <span>{{activity.amount_weight-0}}公斤</span>
                          </template>
                          <!-- <span class="jiantou"> >> </span> -->
                          <br>
                          <span>{{operateList[activity.operate -1 ]}}后：</span>
                          <template v-if="activity.goods_bale == 1">
                            <span>{{activity.after_num-0}}{{unit_list[activity.num_unit-1].name}}</span>
                          </template>
                          <template v-if="activity.goods_bale == 2">
                            <span>{{activity.after_num-0}}{{unit_list[activity.num_unit-1].name}}</span>
                            (<span>{{activity.after_weight-0}}公斤</span>)
                          </template>
                          <template v-if="activity.goods_bale == 3">
                            <span>{{activity.after_weight-0}}公斤</span>
                          </template>
                        </span>
                        <div class="jiantou" style="color:#999;">操作员：{{activity.realname}}</div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </div>
            </template>
          </div>
          <!-- 底部 -->
          <div class="pop_footer" v-if="item.status != 2">
            <span class="p_f_bs">
              <button @click="submitData">保存</button>
            </span>
            <span class="p_f_bs">
              <button @click="cancelPop">取消</button>
            </span>
          </div>
        </div>
      </md-popup>
    </div>
  </div>
</template>
<script>
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import { goods_detail,goods_update,goodsBatch_data} from "@/api/work/stock";
export default {
  name: "goodsDetail",
  data() {
    return {
      show:false,
      goods_id:"",
      item: {},
      operateList:["盘点","报损","补货","退货","修改库存","报溢"],
      active_input:'',
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      subData:{
        goods_id:'',
        name:'',
        type:'',
        proposed_price:'',
        is_strong:"",
      },
      timeline:[],
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 显示弹窗
    showPop(batch_id,item){
      this.goods_id = item.id
      this.show = true
      this.getTimeLine(batch_id,item.batch)
      goods_detail({goods_id:this.goods_id}).then(res=>{
        if(res.code == 200 ){
          this.item = res.data
          this.subData.goods_id = res.data.id
          this.subData.name = res.data.name
          this.subData.type = res.data.type+''
          this.subData.is_strong = res.data.is_strong+''
          this.subData.proposed_price = Number(res.data.proposed_price)
        }
      })
    },
    // 保存
    submitData(){
      goods_update(this.subData).then(res=>{
        if(res.code == 200){
          this.$toast.succeed(res.message)
          this.finishPop()
        }
      })
    },
    // 取消弹窗
    cancelPop(){
      this.show = false
      this.resetData()
      this.$emit("cancel")
    },
    // 完成弹窗
    finishPop(){
      this.show = false
      this.resetData()
      this.$emit("finish")
    },
    // 重置数据
    resetData(){
      this.subData = {
        goods_id:'',
        name:"",
        type:"1",
        is_strong:"",
        proposed_price: ""
      }
      this.item = {}
    },

    // 获取时间轴
    getTimeLine(batch_id,goods_batch){
      var listQuery = {
        page:1,
        pageSize:10000,
        batch_id,
        goods_batch,
      }
      goodsBatch_data(listQuery).then(res=>{
        this.timeline = res.data.list
      })
    }
  }
};
</script>
<style lang="less" scoped>
.goodsDetail {
  // 弹出层
  .pop_goods_box {
    width: 5.8rem;
    height: calc(100% - 0.54rem);
    background-color: #fff;
    .pop_header {
      height: 0.68rem;
      width: 100%;
      text-align: center;
      font-size: 0.28rem;
      line-height: 0.68rem;
      position: relative;
      box-shadow: 0 0.02rem 0.04rem 0.02rem #e1e1e1;
      .close {
        position: absolute;
        left: 0.2rem;
        top: 0;
      }
    }
    .pop_section {
      width: 100%;
      height: calc(100% - 0.68rem);
      overflow: scroll;
      padding: 0.1rem;
      padding-bottom: 0.6rem;
      .goods_base {
        padding: 0.1rem 0.15rem 0.15rem;
        border-bottom: 0.01rem solid #e1e1e1;
        .goods_name {
          height: 0.48rem;
          display: flex;
          align-items: flex-end;
          justify-content: flex-start;
          margin-bottom: 0.06rem;
          .label{
            font-size: 0.2rem;
            color: #666;
          }
          & > span {
            font-size: 0.28rem
            // margin-right: 0.1rem;
          }
        }
      }
      .input_name{
        border: 0.01rem solid #ddd;
        padding: 0.04rem 0;
        line-height: 0.4rem;
        border-radius: 0.04rem;
        // background-color: #e1e1e1;
        width: 100%;
        font-size: 0.24rem;
        color: #2c3e50;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &[active]{
          border-color: #31b158;
        }
        span.label{
          font-size: 0.2rem;
          color: #666;
        }
        input{
          flex: 1;
          width: 100%;
          padding: 0 0.15rem;
          font-size: 0.24rem;
          background-color: transparent;
        }
      }
      .goods_label {
        font-size: 0.2rem;
        color: #666;
        line-height: 0.32rem;
        >span{
          .radio{
            font-size: 0.2rem;
          }
        }
      }
      .goods_num {
        padding: 0.15rem;
        border-bottom: 0.01rem solid #e1e1e1;
      }
      .goods_brake {
        padding: 0.15rem;
        .title {
          padding-bottom: 0.1rem;
        }
        .content {
          padding: 0.1rem 0.08rem;
          .timeline{
            color: #666;
            .jiantou{
              color: #666;
            }
          }
        }
      }
    }
    .pop_footer {
      height: 0.72rem;
      width: 100%;
      position: absolute;
      bottom: 0;
      z-index: 3;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0 0.15rem;
      box-shadow: 0 0 0.04rem 0.02rem #e1e1e1;
      span {
        // margin-left: 0.1rem;
        button {
          width: 1rem;
          height: 0.48rem;
          line-height: 0.48rem;
          padding: 0 0.12rem;
          border-radius: 0.04rem;
          color: #fff;
          background-color: #ff0000;
          border: 0.01rem solid #ff0000;
          font-size: 0.24rem;
          box-sizing: content-box;
          letter-spacing: 0.08rem;
          &:active {
            background-color: #d11111;
          }
        }
        &.p_f_bs,
        &.p_f_by {
          button {
            border: 0.01rem solid #31b158;
            background-color: #31b158;
            color: #fff;
            &:active {
              background-color: #50cf76;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.goodsDetail{
  .md-popup-mask{
    top: 0.54rem;
    left: 0.7rem;
  }
  .md-radio-group{
    display: flex;
    align-items: center;
    .md-radio{
      margin-left: 0.4rem;
      margin-right: 0.2rem;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
}

</style>